// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bscbo1{position:relative;background-color:rgba(6,30,93,.5);box-sizing:border-box}#bscbo1,#bscbo1 .box{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
